import { CalendarDays } from "lucide-react";
import { DailyCommissionDetailItem } from "../../../../../Redux/referral/types";
import { formatEarningsCurrency } from "../../earningsAdapters";

interface Props {
  data: DailyCommissionDetailItem[];
  loading?: boolean;
}

const DailyCommDetailsTable = ({ data, loading }: Props) => {
  return (
    <div className="daily-ref-desktop-table-wrap">
      <table className="daily-ref-table daily-ref-details-table">
        <colgroup>
          <col className="daily-ref-col-sno" />
          <col className="daily-ref-col-date" />
          <col className="daily-ref-col-person" />
          <col className="daily-ref-col-earned-detail" />
        </colgroup>
        <thead>
          <tr>
            <th>S.NO</th>
            <th>DATE</th>
            <th>CONTRIBUTORS</th>
            <th>EARNED INCENTIVES</th>
            <th>TDS</th>
            <th>NET AMOUNT</th>
            <th>PARTNER GROWTH INCENTIVE</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7}>Loading...</td>
            </tr>
          ) : data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>
                  <span className="daily-ref-sno-cell">{item.sNo}</span>
                </td>
                <td>
                  <span className="daily-ref-month">
                    <CalendarDays size={15} />
                    <strong>{item.date}</strong>
                  </span>
                </td>
                <td>
                  <strong>{item.contributors}</strong>
                </td>
                <td>
                  <strong className="daily-ref-earned">
                    {formatEarningsCurrency(item.grossAmount ?? item.receivedIncentives)}
                  </strong>
                </td>
                <td>
                  <strong className="daily-ref-earned">
                    {formatEarningsCurrency(item.tdsAmount ?? 0)}
                    {item.tdsIsEstimated ? " (est)" : ""}
                  </strong>
                </td>
                <td>
                  <strong className="daily-ref-earned">
                    {formatEarningsCurrency(item.netAmount ?? item.receivedIncentives)}
                  </strong>
                </td>
                <td>
                  <strong className="daily-ref-earned">
                    {formatEarningsCurrency(
                      item.partnerGrowthReferralIncentive,
                    )}
                  </strong>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7}>No details found for this period</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DailyCommDetailsTable;
